export const upperCaseFirst = str => {
  const safeStr = str || '';
  return safeStr.charAt(0).toUpperCase() + safeStr.substr(1);
};

const path = {
  transporttype: data => ({
    header: `Продажа ${data.transportTypePluralGenitive} в Украине`,
    header_uk: `Продаж ${data.transportTypePluralGenitive} в Україні`,

    title: `${upperCaseFirst(
      data.transportTypePlural,
    )}: купить ${data.transportTitle} в Украине бу или новый - Автобазар`,
    title_uk: `${upperCaseFirst(
      data.transportTypePlural,
    )}: купити ${data.transportTitle} в Україні бу або новий - Автобазар`,

    description: `Купить ${data.transportTitle} с пробегом или новый ⭐ Цены на ${data.transportTypePlural}, характеристики, фото и большой выбор коммерческого транспорта на сайте Автобазар`,
    description_uk: `Купити ${data.transportTitle} з пробігом або новий ⭐ Ціни на ${data.transportTypePlural}, характеристики, фото та великий вибір комерційного транспорту на сайті Автобазар`,
  }),

  make_transporttype: data => ({
    header: `${upperCaseFirst(data.transportTypePlural)} ${data.make} в Украине`,
    header_uk: `${upperCaseFirst(data.transportTypePlural)} ${data.make} в Україні`,

    title: `${upperCaseFirst(
      data.transportTitle,
    )} ${data.makeTranslit} в Украине, купить ${data.transportTypePlural} ${data.make} бу или новые - Автобазар`,
    title_uk: `${upperCaseFirst(
      data.transportTitle,
    )} ${data.makeTranslit} в Україні, купити ${data.transportTypePlural} ${data.make} бу або нові - Автобазар`,

    description: `Купить ${data.transportTypePlural} ${data.make} новые или с пробегом ⭐ Цены на ${data.transportTypePlural}, характеристики, фото и большой выбор коммерческого транспорта на сайте Автобазар`,
    description_uk: `Купити ${data.transportTypePlural} ${data.make} нові або з пробігом ⭐ Ціни на ${data.transportTypePlural}, характеристики, фото та великий вибір комерційного транспорту на сайті Автобазар`,
  }),

  make_model_transporttype: data => ({
    header: `Продажа ${data.make} ${data.model}`,
    header_uk: `Продаж ${data.make} ${data.model}`,

    title: `Продажа ${data.makeTranslit} ${data.modelTranslit} бу и новых: купить ${data.make} ${data.model} в Украине. Цена на грузовики, фото - Автобазар`,
    title_uk: `Продаж ${data.makeTranslit} ${data.modelTranslit} бу та нових: купити ${data.make} ${data.model} в Україні. Ціна на вантажівки, фото - Автобазар`,

    description: `Купить ${data.make} ${data.model} новые и с пробегом 🚌 в Украине ⭐ Удобный поиск по объявлениям поможет Вам купить грузовики ${data.makeTranslit} ${data.modelTranslit} по выгодной цене на Автобазаре`,
    description_uk: `Купити ${data.make} ${data.model} нові та з пробігом 🚌 в Україні ⭐ Зручний пошук по оголошеннях допоможе Вам купити вантажівки ${data.makeTranslit} ${data.modelTranslit} за вигідною ціною на Автобазарі`,
  }),
};

export default path;



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/commercial/gruzovye/templates.js